<template>
    <div ref="container" class="container d-flex flex-column h-100">
        <div>
            <header class="text-center pt-4" style="z-index: 100;">
                <div ref="header" class="patient-banner d-flex">
                    <div style="width:50px">
                        <img src="img/egl/myaccount-standard2.svg" alt="profile icon">
                    </div>
                    <div v-if='$route.params.user_id' class="w-100 border-bottom pb-2">
                        <p><strong v-text="getSelectedUserName($root.user)"></strong></p>
                        <p><small>{{providerName}} {{providerStatus}}</small></p>
                    </div>
                </div>
            </header>

            <div class='card-default'>
                
                <template v-if='!isServiceAvailable()'>

                    <custom-action-selector 
                        init_type='patient' 
                        :custom_actions="outOfHoursCustomActions()"
                        :user_id="$route.params.user_id">
                    </custom-action-selector>
                    
                    <router-link v-if='!$root.provider || tBrandSetting("conf_quick_self_help")' :to='{name: "selfHelp", "params": {"user_id": $route.params.user_id}}' tag="button" class="card-button w-100 mb-2">
                        <div class="card-icon"><img src="/img/egl/icon-placeholder.svg" alt="link icon"></div>
                        <div><h2>{{ $t('translations.quick_self_help')}}</h2></div>
                    </router-link>
                    <!-- <router-link v-else :to='{name: "selfHelp"}' tag="button" class="btn btn-round btn-block btn-primary">{{ $t('translations.quick_self_help')}}</router-link> -->
                    
                    <h2 class="m-2 text-center">
                        <span class="icon-appointment mt-4 mb-3">
                            <svg x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><path id="Shape" 
                            d="M18,12c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S14.7,12,18,12z M18,13.5c-2.5,0-4.5,2-4.5,4.5
            s2,4.5,4.5,4.5s4.5-2,4.5-4.5S20.5,13.5,18,13.5z M15,0c0.5,0,0.9,0.4,1,0.9L16,1v1h2c1.6,0,2.9,1.2,3,2.8L21,5v4
            c0,0.5-0.4,0.9-0.9,1L20,10H3v9c0,0.5,0.4,0.9,0.9,1L4,20h6c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1L10,22H4c-1.6,0-2.9-1.2-3-2.8
            L1,19V5c0-1.6,1.2-2.9,2.8-3L4,2h2V1c0-0.6,0.4-1,1-1c0.5,0,0.9,0.4,1,0.9L8,1v1h6V1C14,0.4,14.4,0,15,0z M18,14.2
            c0.4,0,0.7,0.3,0.7,0.6l0,0.1v2.6l1.7,1.3c0.3,0.2,0.4,0.6,0.2,1L20.6,20c-0.2,0.3-0.6,0.4-1,0.2l-0.1-0.1l-2-1.5
            c-0.2-0.1-0.3-0.3-0.3-0.5l0-0.1v-3C17.2,14.6,17.6,14.2,18,14.2z M6,4H4C3.5,4,3.1,4.4,3,4.9L3,5v3h16V5c0-0.5-0.4-0.9-0.9-1L18,4
            h-2v1c0,0.5-0.4,0.9-0.9,1L15,6c-0.5,0-0.9-0.4-1-0.9L14,5V4H8v1c0,0.5-0.4,0.9-0.9,1L7,6C6.5,6,6.1,5.6,6,5.1L6,5V4z"/></g></svg>
                        </span>
                        <template v-if='$root.provider.network_service_status == 0'>
                            {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
                        </template>
                        <template v-else>
                            {{ serviceAvailabliltyMessage() }}
                        </template>
                    </h2>
                </template>
                <template v-else>
                    <router-link v-if='!$root.provider || tBrandSetting("conf_quick_self_help")' :to='{name: "selfHelp", "params": {"user_id": $route.params.user_id}}' tag="button" class="card-button w-100 mb-2">
                        <div class="card-icon"><img src="/img/egl/icon-placeholder.svg" alt="link icon"></div>
                        <div><h2>{{ $t('translations.quick_self_help')}}</h2></div>
                    </router-link>
                    
                    <custom-action-selector 
                        init_type='patient' 
                        :custom_actions="$root.provider.custom_action"
                        :user_id="$route.params.user_id">
                    </custom-action-selector>
                </template>

            </div>

            <footer class="container">
                <!-- REpeat prescriptions <router-link :to="{ name: 'prescriptions', params: {} }" class="btn btn-round">Repeat prescriptions</router-link> -->
                <a v-if='tBrandSetting("conf_emergency_banner")' href="https://www.nhs.uk/using-the-nhs/nhs-services/urgent-and-emergency-care/when-to-call-999/" class="alert alert-danger text-center d-block">{{ $t('translations.do_not_use_in_emergencies')}}</a>
            </footer>


        </div>
        <div v-if='tBrandSetting("conf_show_licence_agreement")' class="mt-auto w-100 p-2">
            <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use') }}</a></strong></p>
        </div>
        <div v-else class="pb-5"></div>

    </div><!--ref:container-->


</template>

<script>
var moment = require('moment');
export default {
    props: [
    ],
    data: function(){
        return {
            scrollTo: null,
        }
    },
    mounted() {
    },
    computed: {
        charactersLeft() {
            var char = this.$root.selfHelpSearch.length;
            var limit = 50;

            if(char > limit) {
                this.$root.selfHelpSearch = this.$root.selfHelpSearch.substr(0, limit);
                char = this.$root.selfHelpSearch.length;
            }
            return (limit - char) + " " + this.$t('translations.characters_left') + ".";
        },
        providerName: function() {
            if(this.$root.provider) {
                return this.$root.provider.name;
            }
            return "";
        },
        providerStatus: function() {
            if(!this.isServiceAvailable()) {
                return "(" + this.$t('translations.offline') + ")"
            }
            return "";
        },
    },
    methods: {
        getSelectedUserName() {
            if(this.$route.params.user_id) {
                var selectedUser;

                if(this.$route.params.user_id != this.$root.user.id) {
                    selectedUser = this.getCaree(this.$route.params.user_id);
                }
                else {
                    selectedUser = this.$root.user;
                }
                if(selectedUser) {
                    return selectedUser.forenames + " " + selectedUser.surname + " " + this.formatDate(selectedUser.dob);
                }
                else {
                    this.$router.push({name: "Profile"});
                }
            }
        },
    }
}
</script>
